exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".zillow__note[data-v-7ed5e14f] {\n  font-size: .8em;\n}\n", ""]);

// exports
